<div class="dropdown show devicepicker" id="{{id}}">
  <button class="btn {{#if styleClass}}{{styleClass}}{{else}}btn-white{{/if}} dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" data-id="ct-dropdown-toggle" aria-haspopup="true" aria-expanded="false">
    <div class="m-l-5 dropdown-ellipse">
        <span class="text pull-left">
            {{text}}{{#unless text}}&nbsp;{{/unless}}
        </span>
        <span class="bs-caret pull-right">
            <span class="caret"></span>
        </span>
    </div>
  </button>
    <div class="dropdown-menu" role="menu">
        <div class="js-dropdown-filter-box">
            <input type="text" class="form-control js-filter">
        </div>
        <div class="devicepicker-content">
            <i class="fa fa-spinner"></i>
        </div>
    </div>
</div>
